module.exports = __webpack_public_path__ + "media/fail.3a64000a.mp3";